export const tableColumnsKeys = {
  name: 'name',
  number: 'number',
  email: 'email',
  is_invalid: 'is_invalid',
  tag: 'tag',
  source: 'source',
  keyword: 'keyword',
  areaCode: 'area_code',
}
